export default "__VITE_ASSET__Bwf1tIsn__"